import {API} from "@/Composables/api";

const getConversationMessages = async (conversation: string, params = {}) => {
    return API.get(route("conversations.messages.index", {conversation}), params);
};

const getConversationMessage = async (conversation: string, message: string, params = {}) => {
    return API.get(route("conversations.messages.show", {conversation, message}), params);
};

const translateConversationMessage = async (conversation: string, message: string, params = {}) => {
    return API.get(route("conversations.messages.translate", {conversation, message}), params);
};

const storeConversationMessage = async (conversation, formData, params = {}) => {
    const form = new FormData();
    form.append("body", formData.body);

    if (formData.attachments && formData.attachments.length > 0) {
        formData.attachments.forEach((file, index) => {
            form.append(`attachments[${index}]`, file);
        });
    }

    return API.post(route("conversations.messages.store", conversation), params, form);
};

const deleteConversationMessage = async (conversation, message, params = {}) => {
    return API.delete(route("conversations.messages.destroy", {conversation, message}), params);
};

const restoreConversationMessage = async (conversation, params = {}) => {
    return API.put(route("conversations.messages.restore", {conversation}), params);
};

export {
    getConversationMessages,
    getConversationMessage,
    translateConversationMessage,
    storeConversationMessage,
    deleteConversationMessage,
    restoreConversationMessage,
};
